'use strict';
var InternationalAdjustmentController = /** @class */ (function () {
    /* @ngInject */
    function InternationalAdjustmentController($scope, $log, $mdDialog, CartService, Util) {
        var _this = this;
        this.type = "brandName";
        this.showItem = true;
        this.currentIndex = null;
        this.loadingQuantity = null;
        this.showEmptyMessage = false;
        this.$scope = $scope;
        this.$log = $log;
        this.$mdDialog = $mdDialog;
        this.CartService = CartService;
        this.Util = Util;
        this.CartService.subscribe($scope, function (event, data) {
            _this.items = data.aresLineItems;
            _this.loadingQuantity = null;
        });
        this.$scope.$on('getItemsAdjusted', function (event, data) {
            _this.$scope.$emit('sendItemsAdjusted', _this.itemsAdjusted);
        });
    }
    InternationalAdjustmentController.prototype.setCurrentIndex = function (id) {
        this.currentIndex = this.currentIndex == id ? null : id;
        this.showItem = false;
    };
    InternationalAdjustmentController.prototype.cancelRemove = function () {
        this.currentIndex = null;
        this.showItem = true;
    };
    InternationalAdjustmentController.prototype.confirmRemove = function (id) {
        var index = this.itemsAdjusted.findIndex(function (order) { return order.itemId == id; });
        this.itemsAdjusted[index].quantity = 0;
        this.itemsAdjusted[index].showItem = false;
        this.currentIndex = null;
        this.showItem = true;
        var length = 0;
        this.itemsAdjusted.filter(function (item) {
            if (item.quantity === 0) {
                length++;
            }
        });
        if (length === this.itemsAdjusted.length) {
            this.showEmptyMessage = true;
        }
    };
    InternationalAdjustmentController.prototype.decrement = function (id) {
        this.currentIndex = null;
        var index = this.itemsAdjusted.findIndex(function (order) { return order.itemId == id; });
        var quantity = parseInt(this.itemsAdjusted[index].quantity);
        if (quantity - 1 == 0) {
            this.setCurrentIndex(id);
        }
        else {
            this.itemsAdjusted[index].quantity = quantity - 1;
        }
    };
    InternationalAdjustmentController.prototype.increment = function (id) {
        this.currentIndex = null;
        var index = this.itemsAdjusted.findIndex(function (order) { return order.itemId == id; });
        var quantity = parseInt(this.itemsAdjusted[index].quantity);
        if (quantity >= this.itemsAdjusted[index].onHandQuantity) {
            this.$scope.showUpdateBtn = false;
            return;
        }
        this.itemsAdjusted[index].quantity = quantity + 1;
    };
    InternationalAdjustmentController.prototype.updateQuantity = function (id, newQuantity) {
        var index = this.itemsAdjusted.findIndex(function (item) { return item.itemId == id; });
        var minimumSaleQuantity = this.itemsAdjusted[index].minimumSaleQuantity;
        var onHandQuantity = this.itemsAdjusted[index].onHandQuantity;
        var isOnVendorBackOrder = this.itemsAdjusted[index].isOnVendorBackOrder;
        this.loadingQuantity = id;
        if (newQuantity == undefined || newQuantity == 0) {
            this.confirmRemove(id);
            return;
        }
        if (newQuantity !== undefined && onHandQuantity > 0) {
            if (newQuantity > onHandQuantity) {
                if (isOnVendorBackOrder) {
                    this.Util.setPageErrors("Currently on backorder with our brand partner. Item is available in limited\n               quantities. If the quantity requested is more than what is available, the quantity will be reduced\n               to the remaining quantity.", '', this);
                }
                else {
                    this.Util.setPageErrors("Item Has Been Discontinued. Item is available in limited quantities. If the\n               quantity requested is more that what is available, the quantity will be reduced to the remaining\n               quantity.", '', this);
                }
                this.showAlert = true;
                this.itemsAdjusted[index].quantity = onHandQuantity;
                this.loadingQuantity = null;
                return;
            }
            else if (newQuantity < minimumSaleQuantity) {
                this.Util.setPageErrors("Minimum Quantity Required. If the quantity requested is less that what is required,\n             the quantity will be increased to the minimum quantity.", '', this);
                this.itemsAdjusted[index].quantity = minimumSaleQuantity;
                this.loadingQuantity = null;
                return;
            }
            else {
                this.itemsAdjusted[index].quantity = newQuantity;
                this.loadingQuantity = null;
            }
            this.itemsAdjusted[index].totalPrice = this.itemsAdjusted[index].quantity * this.itemsAdjusted[index].unitPrice;
        }
    };
    InternationalAdjustmentController.prototype.closePopup = function () {
        this.$mdDialog.hide();
    };
    InternationalAdjustmentController.prototype.adjustQuantity = function (item) {
        var removeErrorCodeList = [109, 115, 875, 876, 878];
        var adjustQuantity = item.onHandQuantity;
        item.errors.forEach(function (err) {
            if (removeErrorCodeList.indexOf(err.code) > -1)
                adjustQuantity = 0;
        });
        item.warnings.forEach(function (warning) {
            if (removeErrorCodeList.indexOf(warning.code) > -1)
                adjustQuantity = 0;
        });
        return adjustQuantity;
    };
    InternationalAdjustmentController.prototype.$onChanges = function (changes) {
        var _this = this;
        if (changes.itemsAdjusted) {
            this.itemsAdjusted.filter(function (item) {
                if (item.onHandQuantity > 0) {
                    item.onHandQuantity = _this.adjustQuantity(item);
                    item.quantity = Math.min(item.quantity, item.onHandQuantity);
                }
                else {
                    item.quantity = 0;
                }
                item.showItem = true;
            });
        }
        this.loadingQuantity = null;
    };
    InternationalAdjustmentController.prototype.$onInit = function () {
        this.$scope.showUpdateBtn = false;
    };
    return InternationalAdjustmentController;
}());
export default InternationalAdjustmentController;
//# sourceMappingURL=adjustment-intership.controller.js.map